// extracted by mini-css-extract-plugin
module.exports = {"search-form":"SearchBar_search-form__U_qQr","search-input":"SearchBar_search-input__1mgmj"};